export default __webpack_public_path__ + "static/media/settingsBlue.33d83d0c.svg";